import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateBranch } from "../api/queries";
import { BranchForm } from "../ui/BranchForm";

export function BranchesCreatePage() {
  const nav = useNavigate({ from: "/app/branches/create" });
  const createBranch = useCreateBranch();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ສາຂາ",
              to: "/app/branches",
            },
            {
              label: "ສ້າງສາຂາ",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6 flex flex-wrap items-center justify-between gap-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ສ້າງສາຂາ
            </h2>
            <p className="text-muted-foreground">
              ຈັດການຕຳແໜ່ງສາຂາ ລັງສີບໍລິການ ແລະ ເວລາເປີດໃຫ້ບໍລິການ.
            </p>
          </div>
          <Button variant="outline" onClick={() => nav({ to: "/app/branches" })}>
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <BranchForm
          onSubmit={async (vals) => {
            try {
              await createBranch.mutateAsync({
                code: vals.code,
                name: vals.name,
                phone: vals.phone ?? null,
                address: vals.address ?? null,
                lat: vals.lat ?? null,
                lng: vals.lng ?? null,
                serviceRadiusM: vals.serviceRadiusM ?? null,
                timezone: vals.timezone ?? null,
                openHoursJson: vals.openHoursJson,
                isActive: vals.isActive,
                isDistributionHub: vals.isDistributionHub,
              });
              toast.success("ສ້າງສາຂາສຳເລັດ", {
                description: "ສາຂາຖືກສ້າງແລ້ວ",
              });
              nav({ to: "/app/branches" });
            } catch {
              // onError in mutation shows toast
            }
          }}
          submitting={createBranch.isPending}
          onCancel={() => nav({ to: "/app/branches" })}
        />
      </Main>
    </>
  );
}
